import { Box, Card, Divider, Grid, Typography } from '@material-ui/core'
import clsx from "clsx"
import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next"
import BrakingEventsIcon from "../../assets/images/braking.svg"
import CorneringEventsIcon from "../../assets/images/cornering.svg"
import AccelerationEventsIcon from "../../assets/images/acceleration.svg"
import PhoneIcon from "../../assets/images/phone.svg"
import SpeedingEventsIcon from "../../assets/images/speeding.svg"
import { useStyles } from "../../assets/jss/DriverTripCard"
import DateTime from "../DateTime/DateTime"
import CustomLink from '../CustomComponents/CustomLink/CustomLink'
import { getUserData, getUserRBAC } from "../../services/LocalStorageService";
import { Role, RBAC_CODE, EntityAccess } from "../../config/app-globals.enum";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

function DriverTripCard(props) {
    const { t, i18n } = useTranslation();
    const { selectedTrip } = props;
    const classes = useStyles();
    const [userData] = React.useState(getUserData);
    const [getRBAC] = React.useState(getUserRBAC(null, props));
    // const [expandDriverCard, setExpandDriverCard] = useState(true);
    const openSwitchTripDialog = () => {
        props.setIsSwitchTripDialogOpened(true);
    }
    function setSelectedTrip() {
        props.setSelectedTrip(null);
    }

    useEffect(() => {
        if (props.expandDriverCard) {
            initialCardView();
        }

    }, [props.expandDriverCard]);

    function initialCardView() {
        document.getElementById("tripEndComponent").style['display'] = 'block';
        document.getElementById("tripEndDivider").style['display'] = 'block';
        document.getElementById("tripDistanceComponent").style['display'] = 'block';
        document.getElementById("tripDistanceDivider").style['display'] = 'block';
        document.getElementById("tripEventDataComponent").style['display'] = 'block';
        if (userData.userRoleId === Role.DRIVER && getRBAC && getRBAC.find((item) => item.entityCode === RBAC_CODE.SWITCH_TRIP_VIEW && item.isAccessible === EntityAccess.ALLOWED)) {
            document.getElementById("tripEventDataDivider").style['display'] = 'block';
            document.getElementById("switchTripComponent").style['display'] = 'block';
        }
    }

    function driverCardClick() {
        props.setExpandDriverCard(!props.expandDriverCard);
        if (props.expandDriverCard) {
            document.getElementById("tripEndComponent").style['display'] = 'none';
            document.getElementById("tripEndDivider").style['display'] = 'none';
            document.getElementById("tripDistanceComponent").style['display'] = 'none';
            document.getElementById("tripDistanceDivider").style['display'] = 'none';
            document.getElementById("tripEventDataComponent").style['display'] = 'none';
            if (userData.userRoleId === Role.DRIVER && getRBAC && getRBAC.find((item) => item.entityCode === RBAC_CODE.SWITCH_TRIP_VIEW && item.isAccessible === EntityAccess.ALLOWED)) {
                document.getElementById("tripEventDataDivider").style['display'] = 'none';
                document.getElementById("switchTripComponent").style['display'] = 'none';
            }
        } else {
            document.getElementById("tripEndComponent").style['display'] = 'block';
            document.getElementById("tripEndDivider").style['display'] = 'block';
            document.getElementById("tripDistanceComponent").style['display'] = 'block';
            document.getElementById("tripDistanceDivider").style['display'] = 'block';
            document.getElementById("tripEventDataComponent").style['display'] = 'block';
            if (userData.userRoleId === Role.DRIVER && getRBAC && getRBAC.find((item) => item.entityCode === RBAC_CODE.SWITCH_TRIP_VIEW && item.isAccessible === EntityAccess.ALLOWED)) {
                document.getElementById("tripEventDataDivider").style['display'] = 'block';
                document.getElementById("switchTripComponent").style['display'] = 'block';
            }
        }
    }

    return (
        <Card elevation={2} className={classes.cardWrapper}>
            {/* <IconButton aria-label="close" className={classes.tripCardPopUpCloseButton} onClick={setSelectedTrip} >
                <CloseIcon />
            </IconButton> */}
            <IconButton onClick={() => { driverCardClick() }} onTouchEndCapture={() => { driverCardClick() }} className={classes.driverLocatorExpandButton}>
                {props.expandDriverCard ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </IconButton>
            <Box className={classes.tripItem}>
                <Box className={classes.tripItemRow}>
                    <Box className={classes.tripItemIconBox}>
                        <Box className={classes.tripItemIconStart}>
                        </Box>
                        <Box className={classes.dottedLine}></Box>
                    </Box>
                    <Box className={classes.tripItemSideBox}>
                        <Box className={props.getAddressFromObject(selectedTrip.startAddress) === t(`LOCATION_DATA_NOT_FOUND`) ? classes.eventNoAddress : classes.eventAddress}>
                            {props.getAddressFromObject(selectedTrip.startAddress)}
                        </Box>
                        <Box className={classes.eventDate}>
                            <DateTime inputDate={selectedTrip.startTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={selectedTrip.startTime} returnFormat="hh:mm A" />
                        </Box>
                    </Box>
                </Box>
                <Box id="tripEndComponent" className={classes.tripItemRow}>
                    <Box className={classes.tripItemIconBox}>
                        <Box className={clsx(classes.tripItemIconEnd)}>

                        </Box>
                    </Box>
                    <Box className={classes.tripItemSideBox}>
                        <Box className={props.getAddressFromObject(selectedTrip.endAddress) === t(`LOCATION_DATA_NOT_FOUND`) ? classes.eventNoAddress : classes.eventAddress}>
                            {props.getAddressFromObject(selectedTrip.endAddress)}
                        </Box>
                        <Box className={classes.eventDate}>
                            <DateTime inputDate={selectedTrip.endTime} returnFormat="DD MMM YYYY" /> |{" "}<DateTime inputDate={selectedTrip.endTime} returnFormat="hh:mm A" />
                        </Box>
                    </Box>
                </Box>
                <Divider id="tripEndDivider" light className={classes.dividerClass} />
                <Box id="tripDistanceComponent" className={classes.tripItemRow}>
                    <Grid container justifyContent="space-evenly" className={classes.stateBoxContainer}>
                        <Box className={classes.stateBoxContainerItem}>
                            <Typography component="div" className={classes.stateTitle}>
                                {t("TOTAL_DISTANCE")}
                            </Typography>
                            <Typography component="div" className={classes.stateValue}>
                                {Math.round((selectedTrip.distance + Number.EPSILON) * 100) / 100} {t("MILES")}
                            </Typography>
                        </Box>
                        <Box className={classes.stateBoxContainerItem}>
                            <Typography component="div" className={classes.stateTitle}>
                                {t("TOTAL_TIME")}
                            </Typography>
                            <Typography component="div" className={classes.stateValue}>
                                {Math.floor((selectedTrip.duration) / 60)} {t("MINUTES")}
                            </Typography>
                        </Box>
                    </Grid>
                </Box>
                <Divider id="tripDistanceDivider" light className={classes.dividerClass} />
                <Box id="tripEventDataComponent" className={classes.tripItemRow1}>
                    <Grid container justifyContent="space-evenly" className={classes.stateBoxContainer}>
                        <Grid item className={classes.stateBoxContainerItem}>
                            <Box display="flex" alignItems="center" className={classes.eventBox}>
                                <img className={classes.eventsIcon} src={SpeedingEventsIcon} />
                                <Box className={classes.eventValue}>
                                    {selectedTrip.speedingEventCount}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item className={classes.stateBoxContainerItem}>
                            <Box display="flex" alignItems="center" className={classes.eventBox}>
                                <img className={classes.eventsIcon} src={BrakingEventsIcon} />
                                <Box className={classes.eventValue}>
                                    {selectedTrip.brakingEventCount}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent="space-evenly" className={classes.stateBoxContainer}>
                        <Grid item className={classes.stateBoxContainerItem}>
                            <Box display="flex" alignItems="center" className={classes.eventBox}>
                                <img className={classes.eventsIcon} src={CorneringEventsIcon} />
                                <Box className={classes.eventValue}>
                                    {selectedTrip.corneringEventCount}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item className={classes.stateBoxContainerItem}>
                            <Box display="flex" alignItems="center" className={classes.eventBox}>
                                <img className={classes.eventsIcon} src={AccelerationEventsIcon} />
                                <Box className={classes.eventValue}>
                                    {selectedTrip.accelerationEventCount}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent="space-evenly" className={classes.stateBoxContainer}>
                        <Grid item className={classes.stateBoxContainerItem}>
                            <Box display="flex" alignItems="center" className={classes.eventBox}>
                                <img className={classes.eventsIcon} src={PhoneIcon} />
                                <Box className={classes.eventValue}>
                                    {selectedTrip.distractionEventCount}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {
                    userData.userRoleId === Role.DRIVER && getRBAC &&
                        getRBAC.find(
                            (item) =>
                                item.entityCode === RBAC_CODE.SWITCH_TRIP_VIEW &&
                                item.isAccessible === EntityAccess.ALLOWED)
                        ? (
                            <>
                                <Divider id="tripEventDataDivider" light className={classes.dividerClass} />
                                <Box id="switchTripComponent" textAlign="center">
                                    <CustomLink className={classes.viewDetailLink} href="#" onTouchEndCapture={(e) => { e.preventDefault(); openSwitchTripDialog() }} onClick={(e) => { e.preventDefault(); openSwitchTripDialog() }} underline="none">
                                        {/* {props.selectedTrip && props.selectedTrip.tripType === TripType.BUSINESS ? t("SWITCH_TRIP_TO_PERSONAL_TRIP") : t("SWITCH_TRIP_TO_BUSINESS_TRIP")} */}
                                        {t("RECLASSIFY_TRIP")}
                                    </CustomLink>
                                </Box>
                            </>
                        ) : null
                }

            </Box>
        </Card>
    )
}

export default DriverTripCard